// extracted by mini-css-extract-plugin
export default {"cardTitle":"Title_cardTitle__4S7T9"};